import React, { useCallback } from 'react';
import { PressableIcon, Box, Text, Image } from '@bonanza-social/moonlight';
import { trackEvent, useDispatch, useSelector } from '@bonanza-social/toolkit/state';
import {
  launchGame,
  selectGame,
  selectLastLaunchedGame,
  selectShowLastGameLaunchedToast,
  setShowLastGameLaunchedToast,
} from '../../../state';
import { Pressable } from 'react-native';

const JumpBackInToastContent = () => {
  const dispatch = useDispatch();
  const {
    id: lastLaunchedGameId = '',
    currencyCode: lastLaunchedGameCurrencyCode,
  } = useSelector(selectLastLaunchedGame);

  const showLastGameLaunchedToast = useSelector(
    selectShowLastGameLaunchedToast,
  );
  const game = useSelector(selectGame(lastLaunchedGameId));
  const imageUrl = game?.gameImages?.square?.url;

  const handleClose = useCallback(() => {
    dispatch(setShowLastGameLaunchedToast(false));
    dispatch(
      trackEvent({
        name: 'last_launched_game_toast_hidden',
        params: {
          gameId: game?.id,
        },
      }),
    );
  }, [dispatch, game?.id]);

  const handlePress = useCallback(() => {
    dispatch(
      launchGame({
        id: lastLaunchedGameId,
        currencyCode: lastLaunchedGameCurrencyCode,
      }),
    );
  }, [dispatch, lastLaunchedGameId, lastLaunchedGameCurrencyCode]);

  if (!game || !showLastGameLaunchedToast) {
    return null;
  }

  return (
    <Box
      position="absolute"
      bottom="space-200"
      width={{
        desktop: 364,
        tablet: 364,
        mobile: '95%',
      }}
      alignSelf="center"
      zIndex={1}
    >
      <Pressable onPress={handlePress}>
        <Box
          position="absolute"
          inset={0}
          backgroundColor="screenBackground"
          borderRadius="radius-200"
          opacity={0.95}
        />
        <Box
          position="relative"
          zIndex={1}
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          paddingVertical="space-200"
          paddingHorizontal="space-400"
        >
          <Image
            source={imageUrl}
            width={48}
            height={48}
            contentFit="cover"
            borderRadius="radius-200"
          />
          <Box flex={1} flexDirection="column" marginLeft="space-300">
            <Text
              marginTop="space-100"
              locNS="games"
              locKey="jumpBackInTitle"
              variant="body-s"
              color="darkSurfaceSecondary"
              flex={1}
            />
            <Text
              variant="body-s-semi"
              color="darkSurfacePrimary"
              flex={1}
              marginBottom="space-100"
            >
              {game?.name}
            </Text>
          </Box>
          <PressableIcon
            name="close"
            width="space-600"
            height="space-600"
            color="darkSurfacePrimary"
            onPress={handleClose}
          />
        </Box>
      </Pressable>
    </Box>
  );
};

export default JumpBackInToastContent;
